import { render } from "./SellerAbout.vue?vue&type=template&id=6b1c2488"
import script from "./SellerAbout.vue?vue&type=script&lang=js"
export * from "./SellerAbout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__